import { ArrowUpRight, Bot, Code2, Layers, Rocket, Sparkles, Waypoints, Workflow } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Link } from "react-router";
import { TOPICS, type TopicSlug } from "@jipraks/shared";
import { SectionHeading } from "@client/components/ui/SectionHeading";
import { SpotlightCard } from "@client/components/ui/SpotlightCard";
import { cn } from "@client/lib/cn";
import { homeCopy } from "@client/locales/id/home";
import { layoutCopy } from "@client/locales/id/layout";

const ICONS: Record<TopicSlug, LucideIcon> = {
  n8n: Workflow,
  "ai-agent": Bot,
  automation: Waypoints,
  saas: Rocket,
  "vibe-coding": Code2,
  hermes: Sparkles,
  openclaw: Layers,
};

// Asymmetric bento (design.xml): 6-column grid, one hero tile spanning 4×2.
const SPANS = [
  "md:col-span-4 md:row-span-2",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
];

export function TopicsBento() {
  const copy = layoutCopy.topics;
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 md:py-24">
      <SectionHeading eyebrow={copy.eyebrow} title={copy.title} />
      <div className="mt-10 grid auto-rows-[minmax(10rem,auto)] gap-4 md:grid-cols-6">
        {TOPICS.map((topic, index) => {
          const Icon = ICONS[topic.slug];
          const isHero = index === 0;
          return (
            <SpotlightCard key={topic.slug} className={cn(SPANS[index])}>
              <Link to={`/topics/${topic.slug}`} className="flex h-full flex-col justify-between gap-6 p-6 md:p-8">
                <span className="flex size-11 items-center justify-center rounded-xl border border-border-hover bg-surface">
                  <Icon className="size-5 text-accent-bright" aria-hidden="true" />
                </span>
                <div>
                  <h3 className={cn("flex items-center gap-2 font-semibold tracking-tight", isHero ? "text-2xl md:text-3xl" : "text-lg")}>
                    {topic.name}
                    <ArrowUpRight className="size-4 text-foreground-muted" aria-hidden="true" />
                  </h3>
                  <p className={cn("mt-2 text-foreground-muted", isHero ? "max-w-md text-base" : "text-sm")}>
                    {homeCopy.topicDescriptions[topic.slug]}
                  </p>
                </div>
              </Link>
            </SpotlightCard>
          );
        })}
      </div>
    </section>
  );
}
